import ImageUploadHeading from "components/form/ImageUpload/ImageUploadHeading";
import PropTypes from 'prop-types';
import { useRef, useState } from "react";
import Loader from "components/ui/Loader/Loader";
import useData from "hooks/useData";
import Button from "components/ui/Button/Button";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import { ReactComponent as IconDelete } from "assets/images/icons/close.svg";
import { useConfig } from "context/ConfigContext";
import Alert from "components/ui/Alert/Alert";

const ImageUpload = ({
                       title,
                       subtitle,
                       tooltipMessage,
                       type,
                       bundle,
                       field,
                       currentData,
                       currentValue,
                       onUploaded,
                       onError
                     }) => {
  const { postFile } = useData();
  const uploadRef = useRef();
  const config = useConfig();
  const [imageData, setImageData] = useState(currentData);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState();

  const doUpload = async (file) => {
    setUploading(true);
    setError(null);

    let data;
    let result;
    try {
      result = await postFile(type, bundle, field, file);
    } catch (exception) {
      setError(exception.error);
    }

    switch (result?.status) {
      case 201:
        data = await result.json();
        setImageData(data);
        onUploaded(data);
        break;

      case 422:
        setError(() => 'Het geselecteerde bestand is te groot of heeft niet het juiste formaat, selecteer een afbeelding van maximaal 5 MB en probeer het opnieuw.');
        break;

      default:
        setError(() => `Onbekende fout bij het uploaden (${ result?.status })`);
    }

    if (error && onError) {
      onError(error);
    }

    setUploading(false);
  }

  const handleRemove = () => {
    setImageData(null);
    onUploaded(() => null);
  }

  if (uploading) {
    return <Loader/>
  }

  let currentUpload;
  if (imageData && imageData.uri) {
    currentUpload = <img src={ config.host + imageData.uri[0].url } width="200" alt={ '' }/>;
  } else if (imageData !== null && currentValue) {
    currentUpload = <ResponsiveImage value={ currentValue }/>
  }

  if (currentUpload) {
    return (
      <>
        <ImageUploadHeading title={ title }>
          <Button onClick={ handleRemove } variant={ 'ghost' } className={ 'button--small' }>
            <IconDelete/>
            Vervangen
          </Button>
        </ImageUploadHeading>

        <div className={ 'dialog__profile' }>
          { currentUpload }
        </div>
      </>
    );
  }

  return (
    <>
      { error && <Alert title={ `Uploaden mislukt` } message={ error }/> }
      <ImageUploadHeading
        title={ title }
        subtitle={ subtitle }
        tooltipMessage={ tooltipMessage }
      >
        <Button
          variant={ 'upload' }
          onClick={ () => uploadRef.current.click() }
          className={ 'button--small' }
        >
          Foto uploaden
        </Button>
      </ImageUploadHeading>

      <input
        style={ { display: 'none' } }
        ref={ uploadRef }
        type={ 'file' }
        accept={ 'image/*' }
        onChange={ (event) => doUpload(event.target.files[0]) }/>
    </>
  );
}

ImageUpload.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  currentImageData: PropTypes.array,
  onUploaded: PropTypes.func.isRequired,
  onError: PropTypes.func,
}

export default ImageUpload;
